import styles from './SessionExpiredScreen.module.css';

/**
 * Shown when the account cannot be loaded at all.
 *
 * Telegram's initData is short-lived and re-verified on every request, so an
 * app left open overnight comes back to nothing but rejections. Reopening from
 * the bot mints a fresh one, which is why that is the instruction rather than
 * anything about logging in.
 */
export function SessionExpiredScreen({
  isRetrying,
  onRetry,
}: {
  isRetrying: boolean;
  onRetry: () => void;
}) {
  return (
    <div className={styles.wrap} role="alert">
      <p className={styles.emoji}>🔄</p>
      <p className={styles.title}>Session expired</p>
      <p className={styles.body}>
        This app was open for a while and needs to reconnect. Tap retry, or close and reopen the
        shop from the bot.
      </p>
      <button type="button" className={styles.button} disabled={isRetrying} onClick={onRetry}>
        {isRetrying ? 'Reconnecting…' : 'Retry'}
      </button>
    </div>
  );
}
